import React, { Component } from 'react';
import "../../../css/inventory-style.css";
import "../../../css/general-style.css";
import '../../../css/table-responsive.css';
import styles from '../../../css/AddNewProduct.module.css';
import LoadingWindow from '../../../components/LoadingWindow';
import Select from 'react-select';
import Swal from 'sweetalert2'
import { RiArrowGoBackFill } from 'react-icons/ri';
import { MdPhotoCamera } from 'react-icons/md';
import { getValueCookie } from '../../../services/cookieService';
import { getInformationWithData } from '../../../services/CABE';

// Menu
import { Menu } from "../../../components/Menu/Menu";

export default class AddNewProduct extends Component {

    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        productName: '',
        itemCode: '',
        productLine: '',
        vendorNo: '',   
        upc: '',
        upc2: '',
        caseUpc: '',
        um: '',
        weight: '',
        length: '',
        height: '',
        width: '',
        initialStock: '',
        costPrice: '',
        ProductLineList: [],
        VendorList: [],
        categories: [],
        subcategories: [],
        validForm: false
    }
    
    componentDidMount(){
        this.getProductLines();
        this.getVendor();
    }

    handleSelectChange = async (e) => {
        this.setState({ productLine: e.target.value})
    }

    async getProductLines() {
        const response = await getInformationWithData('/Items/get-exception-items');
        this.setState({ ProductLineList: response.data.data})
    }

    async getVendor() {
        const data = {
            idCompany: getValueCookie('CompanyId')
        }
        const response = await getInformationWithData('/vendors/get/vendorsInformation', data);
        this.setState({ VendorList: response.data})
    }
    
    async getCategories(){
        const response = await getInformationWithData('/v2/items/categories-with-subcategories');
        const { categories, subcategories } = response.data
        this.setState({ categories, subcategories })
    }

    async createProduct() {
        this.checkForm();
    }

    checkForm = async () => {
        
        // Validate the upc values has no letters
        const { itemCode, upc, caseUpc } = this.state;
        
        const upcVal = this.hasLetters(upc);
        const caseUpcVal = this.hasLetters(caseUpc);
        
        if(upcVal || caseUpcVal){
            Swal.fire({
                title: 'Invalid Upc values',
                text: "Some upc has invalid characters.",
                icon: 'warning',
                confirmButtonColor: '#3aa0ff',
                confirmButtonText: 'OK',
            })
            return
        }
        // Validate itemCode and upc are unique
        const responseCheck = await getInformationWithData('/v2/items/exists', {data: {upc, itemCode}})
        const { upc_exists, item_code_exists } = responseCheck.data;
        if(upc_exists > 0 || item_code_exists > 0){
            Swal.fire({
                title: 'Item Code or UPC Already Exists',
                text: "Both the Item Code and the UPC must be unique.",
                icon: 'warning',
                confirmButtonColor: '#3aa0ff',
                confirmButtonText: 'OK',
            })
            return
        }

    }
    
    
    hasLetters(str) {
        return /[a-zA-Z]/.test(str);
    }
    
    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        })
    }

    render() {
        const { ProductLineList, VendorList } = this.state
        const customSelectStyle = {
            control: (provided) => ({
                ...provided,
                border: 'none',
                boxShadow: 'none'
            })
        }

        return (
        <div className='container-fluid'>
            {/* Main menu */}
            <Menu Refresh={this.state.Refresh} Father={this} />
            <LoadingWindow ref={this.ModalLoading} />
            <div className='container'>
                <div className='InventoryInfo lobbyContainer'>
                    <div className="my-5">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h1 className={styles.pageTitle}>Product Information</h1>
                                    <p className={styles.pageSubtitle} id="subtitle">Search or select a product to view and manage its details</p>
                                </div>
                                <div>
                                    <a className="btn btn-primary d-flex align-items-center" href='/inventory/add-new-product'>
                                        <RiArrowGoBackFill />&nbsp;Go back 
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                  {/* <!-- Create Product Content --> */}
                    <div id="createProductContent">
                        <div className="row g-4">
                            {/* <!-- Left Sidebar: Image --> */}
                            <div className="col-lg-3">
                                <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                                    <div className={styles.cardHeaderCustom}>
                                        <h3 className={styles.cardTitle}>Product Image</h3>
                                    </div>
                                    <div className={styles.cardBodyCustom}>
                                        <div className={styles.imageContainer} >
                                            <img src="" alt="New Product" id="createProductImg" style={{display: 'none'}} />
                                            <div className={styles.uploadPlaceholder} id="createPlaceholder">
                                                <div className={styles.uploadIcon}><span><MdPhotoCamera /></span></div>
                                                <p style={{margin: 0, fontWeight: 500}}>Click to upload</p>
                                                <p style={{margin: 0, fontSize: 0.875 + 'rem'}}>PNG, JPG up to 10MB</p>
                                            </div>
                                            <button className={styles.changeBtn}>Upload Image</button>
                                        </div>
                                        <input type="file" id="createFileInput" style={{display: 'none'}} accept="image/*" />
                                        <p className={styles.formHelpText} style={{marginTop: 1 + 'rem'}}>Recommended: Square image, min 800x800px</p>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Right Side: Form --> */}
                            <div className="col-lg-9">
                                <form>
                                    <div className={`${styles.cardModern} ${styles.fadeIn}`} style={{animationDelay: 0.1 +'s'}}>
                                        <div className={styles.cardHeaderCustom}>
                                            <h3 className={styles.cardTitle}>New Product Details</h3>
                                        </div>
                                        <div className={styles.cardBodyCustom}>
                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            Product Name
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <input type="text" name="productName" className={`form-control ${styles.formInput}`} placeholder="Enter product name" required/>
                                                        <p className={styles.formHelpText}>A clear, descriptive name for your product</p>
                                                    </div>
                                                </div>
                                                <div className={`col-md-6  ${styles.formCenter}`}>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                        <label className="form-check-label" for="flexCheckDefault">
                                                            Pre-Sale Product
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className={styles.sectionDivider} />
                                            <h4 className={styles.sectionTitle}>Product Line</h4>

                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                        Item Code
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <input type="text" name="itemCode" className={styles.formInput} placeholder="Enter item code" required />
                                                        <p className={styles.formHelpText}>Include the starting product line characters</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                        Product Line
                                                        <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        {ProductLineList && (
                                                            <Select isSearchable className={styles.formSelect} styles={customSelectStyle} id='ProductLineSelector' name="productLine" placeholder='Choose one' onChange={(e) => this.handleSelectChange(e)} options={ProductLineList.map(pl => ({value: pl.ProductLine, label: pl.ProductLineDesc}))} required />
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                        Primary Vendor
                                                        <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        {VendorList && (
                                                            <Select isSearchable className={styles.formSelect} styles={customSelectStyle} id='VendorSelector' name="vendorNo" placeholder='Choose one' onChange={(e) => this.handleSelectChange(e)} options={VendorList.map(pl => ({value: pl.customerNo, label: pl.name}))} required />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className={styles.sectionDivider} />
                                            <h4 className={styles.sectionTitle}>Product Codes</h4>

                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            UPC
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <input type="text" name="upc" className={styles.formInput} handleChange={this.handleChange} placeholder="012345678901" required />
                                                        <p className={styles.formHelpText}>Barcode number</p>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>UPC 2 (Optional)</label>
                                                        <input type="text" name="upc2" className={styles.formInput} handleChange={this.handleChange} placeholder="098765432109" />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            Case UPC
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <input type="text" name="caseUpc" className={styles.formInput} handleChange={this.handleChange} placeholder="112233445566" required />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>U/M</label>
                                                        <input type="text" name="um" className={styles.formInput} handleChange={this.handleChange} placeholder="112233445566" />
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className={styles.sectionDivider} />
                                            <h4 className={styles.sectionTitle}>Physical Details</h4>

                                            <div className="row g-3">
                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            Weight
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <div className={styles.formInputGroup}>
                                                            <input type="number" name="weight" className={styles.formInput} placeholder="0.0" step="0.1" onWheel={(e) => e.target.blur()} required />
                                                            <span className={styles.inputUnit}>lbs</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            Length
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <div className={styles.formInputGroup}>
                                                            <input type="number" name="length" className={styles.formInput} placeholder="0.0" step="0.1" onWheel={(e) => e.target.blur()} required />
                                                            <span className={styles.inputUnit}>in</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            Height
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <div className={styles.formInputGroup}>
                                                            <input type="number" name="height" className={styles.formInput} placeholder="0.0" step="0.1" onWheel={(e) => e.target.blur()} required />
                                                            <span className={styles.inputUnit}>in</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            Width
                                                            <span className={styles.requiredIndicator}>*</span>
                                                        </label>
                                                        <div className={styles.formInputGroup}>
                                                            <input type="number" name="width" className={styles.formInput} placeholder="0.0" step="0.1" onWheel={(e) => e.target.blur()} required />
                                                            <span className={styles.inputUnit}>in</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className={styles.sectionDivider} />
                                            <h4 className={styles.sectionTitle}>Inventory & Pricing</h4>

                                            <div className="row g-3">
                                                <div className="col-md-4">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>Initial Stock</label>
                                                        <input type="number" name="initialStock" className={styles.formInput} placeholder="0" min="0" />
                                                        <p className={styles.formHelpText}>Starting inventory quantity</p>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>Cost Price</label>
                                                        <div className={styles.formInputGroup}>
                                                            <span className={styles.inputUnit} style={{marginRight: 0.5 + 'rem', marginLeft: 0}}>$</span>
                                                            <input type="number" name="costPrice" className={styles.formInput} placeholder="0.00" step="0.01" onWheel={(e) => e.target.blur()} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <!-- Bottom Action Bar --> */}
                                    <div className={styles.bottomActionBar}>
                                        <div>
                                            <p style={{margin: 0, fontSize: 0.875 + 'rem'}}>
                                                <span className={styles.requiredIndicator}>*</span> Required fields must be filled
                                            </p>
                                        </div>
                                        <div className={styles.btnGroup}>
                                            <button className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`}>Cancel</button>
                                            <button type="submit" className={`${styles.actionBtn} ${styles.btnSuccessCustom}`} onClick={() => this.createProduct()}>Create Product</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
